import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxsModule } from "@ngxs/store";
import { OrderState } from "./state/order.state";
import { OrderService } from "./service/order.service";

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([OrderState])],
  providers: [OrderService]})
export class OrderModule {}
